import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchAssignedUsers, fetchCaseWorkflowStages } from './workflowThunk';


const caseWorkflowStagesSlice = createSlice({
  name: 'caseWorkflowStages',
  initialState: {
    data: {
      workflow_status: [],
      assigned_users: []
    },
    loading: false,
    error: null
  },
  reducers: {
    clearWorkflowStages: (state) => {
      state.data.workflow_status = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaseWorkflowStages.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCaseWorkflowStages.fulfilled, (state, action) => {
        state.loading = false;
        state.data.workflow_status = action.payload.data.workflow_status || [];
        state.error = null;
      })
      .addCase(fetchCaseWorkflowStages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as unknown as any;
        state.data.workflow_status = [];
      });
    builder
      .addCase(fetchAssignedUsers.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssignedUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data.assigned_users = action.payload.data || [];
        state.error = null;
      })
      .addCase(fetchAssignedUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as unknown as any;
        state.data.assigned_users = [];
      });
  },
});

export const {
  clearWorkflowStages,
} = caseWorkflowStagesSlice.actions;

export default caseWorkflowStagesSlice.reducer;